// Copied - Nothing changed
import React from 'react';

interface Props {
  children: React.ReactNode | React.ReactNode[];
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  validate?: boolean;
  className?: string;
}

export const Form: React.FC<Props> = (props: Props) => {
  const { children, onSubmit, validate = true, className } = props;

  return (
    <form className={className} onSubmit={onSubmit} noValidate={!validate}>
      {children}
    </form>
  );
};

export default Form;
